import { Components, Theme } from "@mui/material/styles";

import { Palette } from "../../theme/palette";

export const cardTheme: Partial<
  Pick<Components<Theme>, "MuiCard" | "MuiCardHeader">
> = {
  MuiCard: {
    styleOverrides: {
      root: {
        border: `1px solid ${Palette.SECONDARY["6"]}`, // TODO: use CSS variable
        boxShadow: "none",
        position: "relative",
      },
    },
  },
};
